import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Business } from '../models/business.model';
import { BusinessFuel } from '../models/business-fuel.model';
import { hasTag } from '../../util/tag-utils';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { TagService } from '../../shared/services/tag.service';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { EditFuelComponent } from '../edit-fuel/edit-fuel.component';
import { DeleteFuelComponent } from '../delete-fuel/delete-fuel.component';
var BusinessFuelComponent = /** @class */ (function () {
    function BusinessFuelComponent(_toggleService, _tagService, _businessManagerService, _snackBar, _editFuelDialog, _deleteFuelDialog) {
        var _this = this;
        this._toggleService = _toggleService;
        this._tagService = _tagService;
        this._businessManagerService = _businessManagerService;
        this._snackBar = _snackBar;
        this._editFuelDialog = _editFuelDialog;
        this._deleteFuelDialog = _deleteFuelDialog;
        this.hasTag = hasTag;
        this.editModeSet = false;
        this.isRegionalManager = false;
        this._toggleService.toggleEmitter.subscribe(function (isOn) {
            _this.editModeSet = isOn;
        });
    }
    BusinessFuelComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var allTags, _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this._tagService.getAllTags()];
                    case 1:
                        allTags = _c.sent();
                        this.setPrivate(allTags);
                        _a = this;
                        return [4 /*yield*/, this._businessManagerService.isRegionalManager()];
                    case 2:
                        _b = (_c.sent());
                        if (!_b) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._businessManagerService.userOwnsBusiness(this.business.id)];
                    case 3:
                        _b = !(_c.sent());
                        _c.label = 4;
                    case 4:
                        _a.isRegionalManager = _b;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(BusinessFuelComponent.prototype, "hasContent", {
        get: function () {
            return this.business && this.business.fuel && this.business.fuel.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    BusinessFuelComponent.prototype.GetFuelType = function (input) {
        return BusinessFuel.formatFuelType(input);
    };
    BusinessFuelComponent.prototype.GetServiceType = function (input) {
        return BusinessFuel.formatServiceType(input);
    };
    BusinessFuelComponent.prototype.setPrivate = function (allTags) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._tagService.findTagByName(allTags, 'Fuel::Private')];
                    case 1:
                        _a.privateTag = _b.sent();
                        this.isPrivate = hasTag(this.business.tags, 'Fuel::Private');
                        return [2 /*return*/];
                }
            });
        });
    };
    BusinessFuelComponent.prototype.isChecked = function (tagId) {
        var TAGS = this.business.tags;
        for (var _i = 0, TAGS_1 = TAGS; _i < TAGS_1.length; _i++) {
            var tag = TAGS_1[_i];
            if (tag.tagId === tagId) {
                return true;
            }
        }
        return false;
    };
    BusinessFuelComponent.prototype.checkBoxChanged = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ERROR_MSG, TAG_ID, BUSINESS_ID, newBusiness, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ERROR_MSG = 'Unable to save change, please try back later, or call 1-800-USA-AOPA if the error persists.';
                        TAG_ID = +event.source.id;
                        BUSINESS_ID = this.business.id;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        if (!event.source.checked) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._tagService.postTag(TAG_ID, BUSINESS_ID)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this._tagService.deleteTag(TAG_ID, BUSINESS_ID)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [4 /*yield*/, this._businessManagerService.updateBusiness(this.business)];
                    case 6:
                        newBusiness = _a.sent();
                        Object.assign(this.business, newBusiness);
                        return [3 /*break*/, 8];
                    case 7:
                        e_1 = _a.sent();
                        this._snackBar.open(ERROR_MSG, 'Error', {
                            duration: 6000
                        });
                        throw e_1;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    BusinessFuelComponent.prototype.openEditFuelDialog = function (index) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '60%';
        dialogConfig.data = {
            businessID: this.business.id,
            fuelID: null,
            isNew: false
        };
        index == null ? dialogConfig.data.isNew = true : dialogConfig.data.fuel = this.business.fuel[index];
        dialogConfig.data['busID'] = this.business.id;
        dialogConfig.width = '60%';
        var dialogRef = this._editFuelDialog.open(EditFuelComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                if (isUpdated.isNew) {
                    _this.business.fuel.push(isUpdated.contact);
                    _this._snackBar.open('Fuel', 'Added', {
                        duration: 2000
                    });
                }
                else {
                    _this._snackBar.open('Fuel', 'Updated', {
                        duration: 2000
                    });
                }
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    BusinessFuelComponent.prototype.deleteFuel = function (index) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            businessID: this.business.id,
            fuelID: this.business.fuel[index].id
        };
        var dialogRef = this._deleteFuelDialog.open(DeleteFuelComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                _this._snackBar.open('Fuel Info', 'Deleted', {
                    duration: 2000
                });
                _this.business.fuel.splice(index, 1);
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    return BusinessFuelComponent;
}());
export { BusinessFuelComponent };
